import React, { useEffect, useRef , useState} from 'react';
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { jsPDF } from "jspdf";
import "jspdf-autotable";


const CorrectionPanApplicationAdminReport = () => {
  const [correctionPanData, setCorrectionPanData] = useState([]);
      const tableRef = useRef(null);
      useEffect(() => {
        const fetchCorrectionPanData = async () => {
            try {
                // Retrieve token from localStorage or sessionStorage
                const authToken = localStorage.getItem("authToken"); // or sessionStorage.getItem('token')
                 
                const response = await fetch('https://apiv2.chakran.in/api/CorrectionPan/GetCorrectionPanRecords', {
                //const response = await fetch('http://localhost:5121/api/CorrectionPan/GetCorrectionPanRecords', {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${authToken}`, // Attach token in the request
                        
                    }
                });
  
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
  
                let data = await response.json();
  
                // Add SrNo property to each record
                data = data.map((record, index) => ({
                    ...record,
                    SrNo: index + 1 // Auto-incrementing SrNo
                }));
  
                setCorrectionPanData(data); // Update state with modified data
            } catch (error) {
                console.error('Failed to fetch publication records:', error);
            }
        };
  
        fetchCorrectionPanData();
    }, []);
  
    console.log(correctionPanData);

    // Function to update status
const handleStatusChange = async (registrationNo, newStatus) => {
  const comment = prompt("Enter comment for this status change:");
  if (!comment) return; // Optional: require comment
  
    try {
      const authToken = localStorage.getItem("authToken");
  
      //const response = await fetch(`http://localhost:5121/api/CorrectionPan/updateStatus/${registrationNo}`, {
      const response = await fetch(`https://apiv2.chakran.in/api/CorrectionPan/updateStatus/${registrationNo}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ status: newStatus, comment }),
      });
  
      if (!response.ok) throw new Error("Failed to update status");
  
      // Update UI state
      setCorrectionPanData(prev =>
        prev.map(row =>
          row.registrationNo === registrationNo
            ? { ...row, status: newStatus, comment }
            : row
        )
      );
  
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };


   const generatePDF = (record) => {
      const doc = new jsPDF("p", "pt", "a4");

       // Collect only the correction types that are checked "Yes"
  const correctionTypes = [
    { label: "Name Change/Correction", value: record.nameCorrection },
    { label: "Father's Name Change/Correction", value: record.fatherNameCorrection },
    { label: "Date of Birth Change", value: record.dobCorrection },
    { label: "Photo Change", value: record.photoCorrection },
    { label: "Address Change", value: record.addressCorrection },
    { label: "Signature Change", value: record.signatureCorrection }
  ].filter(item => item.value);
  
      const content = `
    <div aria-label="Submitted form mock" class="paper" role="main">
      <h3 class="text-center">SUBMITTED FORM Correction PAN</h3>
      <div class="meta">
        <div class="left">Registration No <strong>${record.registrationNo || "-"}</strong></div>
        <div class="right">Date : <strong>${record.submissionDate ? new Date(record.submissionDate).toLocaleDateString("en-GB") : "-"}</strong></div>
      </div>
      <div class="form-row"><label>Status Of Applicant</label><input class="input-box small" value="${record.applicantType || "-"}"/></div>
      <div class="form-row"><label>PAN Number</label><input class="input-box small" value="${record.panNo || "-"}"/></div>
      <div class="form-row"><label>Date of Birth / Incorporation</label><input class="input-box small" value="${record.date || record.date || "-"}"/></div>
      <div class="form-row"><label> Contact Details</label>
      <input class="input-box small" value="+91"/>
      <input class="input-box small" value="${record.stdCode || "-"}"/>
      <input class="input-box small" value="${record.mobileNo || "-"}"/>
      </div>
      <div class="form-row"><label>Title (Shri/Smt./Kumari)</label>
        <input class="input-box small" value="${record.applicantCheckedOption || "-"}"/>
      </div>
      <div class="form-row"><label>Name as you would like it, to be printed on the PAN card</label><input class="input-box" value="${record.newPanName || "-"}"/></div>
     
      <div style="margin-top:8px; font-size:13px; font-weight:700;">Applicant Name</div>
      <table style="width:100%; border-collapse:collapse; font-size:12px;" id="nameTable">
        <thead>
          <tr>
            <th style="border:1px solid #000; padding:6px;">First Name</th>
            <th style="border:1px solid #000; padding:6px;">Middle Name</th>
            <th style="border:1px solid #000; padding:6px;">Last Name</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="border:1px solid #000; padding:6px;">${record.firstName || "-"}</td>
            <td style="border:1px solid #000; padding:6px;">${record.middleName || "-"}</td>
            <td style="border:1px solid #000; padding:6px;">${record.lastName || "-"}</td>
          </tr>
        </tbody>
      </table>
      <div class="form-row"><label>Correction Resone</label>
        <ul>
          ${record.changeResoneCheckedOption || "-"}
        </ul>
      </div>
      <div class="form-row"><label>Name as Per Aadhar</label><input class="input-box" value="${record.aadharName || "-"}"/></div>
      <div class="form-row"><label>Aadhaar Number</label><input class="input-box small" value="${record.aadhar_EID || "-"}"/></div>
      <div class="form-row"><label>Email ID</label><input class="input-box" value="${record.emailId || "-"}"/></div>
      <div class="form-row"><label>Pan Card Dispatched State</label><input class="input-box" value="${record.panCardDispatchedState || "-"}"/></div>
      <div class="form-row"><label>Aadhaar/EID</label><input class="input-box" value="${record.aadhar_EID || "-"}"/></div>
      <div class="form-row"><label>Father name</label><input class="input-box small" value="${record.fatherFirstName || "-"}"/>
      <input class="input-box small" value="${record.fatherMiddleName || "-"}"/> <input class="input-box small" value="${record.fatherLastName || "-"}"/>
      </div>

      <div class="form-row"><label>Mother name</label><input class="input-box small" value="${record.motherFirstName || "-"}"/>
      <input class="input-box small" value="${record.motherMiddleName || "-"}"/> <input class="input-box small" value="${record.motherLastName || "-"}"/>
      </div>
      
      <div style="margin-top:10px;"></div>
      <div class="form-row"><label>Flat/ Room/ Bock No.</label><input class="input-box" value="${record.residentRoom || "-"}"/></div>
      <div class="form-row"><label>Name of premises/ Bldg/ Village</label><input class="input-box" value="${record.residentPremises || "-"}"/></div>
      <div class="form-row"><label>Road/ Street/ Lane/ Post</label><input class="input-box" value="${record.residentStreet || "-"}"/></div>
      <div class="form-row"><label>Area/ Locality/ Taluka</label><input class="input-box" value="${record.residentArea || "-"}"/></div>
      <div class="form-row"><label>District</label><input class="input-box" value="${record.residentCity || "-"}"/></div>
      <div class="form-row"><label>State</label><input class="input-box" value="${record.residentState || "-"}"/></div>
      <div class="form-row"><label>PIN Code</label><input class="input-box small" value="${record.residentPinCode || "-"}"/></div>
      
      
      <div class="footer">
        <div class="form-row">
          <label>Retailer Name :</label> <strong>${record.retailerName || "ANIL SURESH LOHRA"}</strong>
        </div>
      </div>
  `;


      doc.html(content, {
        callback: function (doc) {
          doc.save(`CorrectionPanApplication_${record.registrationNo}.pdf`);
        },
        x: 10,
        y: 10,
        html2canvas: { scale: 0.55 },
      });
    };
  
    useEffect(() => {
        if (tableRef.current && correctionPanData.length > 0) {
            const table = $(tableRef.current).DataTable({
                destroy: true, // Destroy existing table instance
                data: correctionPanData,
                columns: [
                  { data: 'SrNo', title: 'Sr No' }, // Dynamically added field
                  { data: 'startDate', title: 'Date' }, // Matches 'startDate'
                  { data: 'name', title: 'Applicant Name' }, // Matches 'name'
                  { data: 'registrationNo', title: 'Registration No' }, // Matches 'registrationNo'
                  {
                    data: 'status',
                    title: 'Status',
                    render: function (data, type, row) {
                        return `
                      <select class="form-control status-dropdown" data-id="${row.registrationNo}">
                        <option value="In Progress" ${data === "In Progress" ? "selected" : ""}>In Progress</option>
                        <option value="Complete" ${data === "Complete" ? "selected" : ""}>Complete</option>
                        <option value="Rejected" ${data === "Rejected" ? "selected" : ""}>Rejected</option>
                        <option value="Refunded" ${data === "Refunded" ? "selected" : ""}>Refunded</option>
                        </select>
                    `;
                    }
                  },
                  { data: 'comment', title: 'Comment' },
                  {
                    data: null,
                    title: "Submitted Form",
                    render: function (data, type, row) {
                        return `<button class='btn btn-sm btn-primary download-btn' data-id='${row.registrationNo}'>Download PDF</button>`;
                    },
                },
                {
                  data: null,
                  title: "PDFDocument",
                  render: function (data, type, row) {
                      return `<button class='btn btn-sm btn-success download-doc-btn' data-id='${row.registrationNo}' data-type='PdfDocument'>Download</button>`;
                  },
              },
              {
                  data: null,
                  title: "Photo",
                  render: function (data, type, row) {
                      return `<button class='btn btn-sm btn-success download-doc-btn' data-id='${row.registrationNo}' data-type='Photo'>Download</button>`;
                  },
              },
              {
                  data: null,
                  title: "Signature",
                  render: function (data, type, row) {
                      return `<button class='btn btn-sm btn-success download-doc-btn' data-id='${row.registrationNo}' data-type='Signature'>Download</button>`;
                  },
              },
              {
                data: null,
                title: "Upload Receipt",
                render: (data, type, row) => `
                 <input type='file' class='file-input' data-id='${row.registrationNo}' style='display:none;' accept='.pdf,.jpg,.png,.docx'/>
                 <button class='btn btn-sm btn-warning upload-btn' data-id='${row.registrationNo}'>Upload</button>
                 
                `,
              }
            //   <br/>
            //     //  <span class='file-name text-success' data-id='${row.registrationNo}'>
            //     //      ${row.PanReceiptPath && row.PanReceiptPath !== "" ? `📄 ${row.PanReceiptPath.split('/').pop()}` : "No file uploaded yet."}
            //     // </span>
              ]
            });

            // Handle status change
            $(tableRef.current).on("change", ".status-dropdown", function () {
              const registrationNo = $(this).attr("data-id");
              const newStatus = $(this).val();
              const comment  = ""; // Or however you get it
              handleStatusChange(registrationNo, newStatus, comment );
            });        

            // Handle download button click
            $('#productsTable tbody').off('click', '.download-btn').on('click', '.download-btn', function () {
              const registrationNo = String($(this).data("id")); // force string
              downloadPDF(registrationNo, "form");
            });
  
            // Handle all other document downloads
            $('#productsTable tbody').off('click', '.download-doc-btn').on('click', '.download-doc-btn', function () {
              const registrationNo = $(this).data("id");
              const fileType = $(this).data("type");
              downloadPDF(registrationNo, fileType);
            });

            // Handle Upload Button Click
            $("#productsTable tbody").off("click", ".upload-btn").on("click", ".upload-btn", function () {
                const registrationNo = $(this).data("id"); // Ensure this is a string
                $(`.file-input[data-id='${registrationNo}']`).trigger("click");
            });
  
            // Handle File Selection
            $("#productsTable tbody").off("change", ".file-input").on("change", ".file-input", function () {
                const registrationNo = $(this).data("id"); // Ensure this is a string
                const file = this.files[0];
                if (file) {
                uploadFile(registrationNo, file);
                }
            });
 
            return () => {
              table.destroy();
              $(tableRef.current).off("change", ".status-dropdown");
            };
        }
    }, [correctionPanData]);

    const downloadPDF = async (registrationNo, type) => {
      try {
          const authToken = localStorage.getItem("authToken");
          // const endpoint = type === "form"
          //     ? `http://localhost:5121/api/CorrectionPan/DownloadPdf/${registrationNo}`
          //     : `http://localhost:5121/api/CorrectionPan/DownloadDocument/${registrationNo}/${type}`;

        const endpoint = type === "form"
            ? `https://apiv2.chakran.in/api/CorrectionPan/DownloadPdf/${registrationNo}`
            : `https://apiv2.chakran.in/api/CorrectionPan/DownloadDocument/${registrationNo}/${type}`;
  
          const response = await fetch(endpoint, {
              method: "GET",
              headers: {
                  Authorization: `Bearer ${authToken}`,
              },
          });
  
          if (!response.ok) {
              throw new Error(`Failed to download file: ${response.status}`);
          }

          if (type === "form") {
            // ✅ API returns JSON (data for form)
            const record = await response.json();
            console.log("📌 API Data:", record);

            // Use frontend design
            generatePDF(record);
          } else {
              const blob = await response.blob();
              const contentType = response.headers.get("Content-Type");
  
              // Determine file extension from MIME type
              const fileExtension = contentType.split("/")[1] || "pdf"; // Example: 'image/png' → 'png'
  
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = `CorrectionPanApplication_${type}_${registrationNo}.${fileExtension}`;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            }
          } catch (error) {
            console.error("Download error:", error);
          }
        };  

    // File Upload Function
    const uploadFile = async (registrationNo, file) => {
        console.log("File selected:", file.name);  // Log the file name here
        try {
          const authToken = localStorage.getItem("authToken");
          const formData = new FormData();
          formData.append("file", file);
      
          // ✅ Use backticks (`) for the correct API URL format
          //const response = await fetch(`http://localhost:5121/api/CorrectionPan/upload-receipt/${registrationNo}`, {
          const response = await fetch(`https://apiv2.chakran.in/api/CorrectionPan/upload-receipt/${registrationNo}`, {
            method: "POST",
            headers: { Authorization: `Bearer ${authToken}` }, // No 'Content-Type' for FormData
            body: formData,
          });
      
          if (!response.ok) {
            throw new Error(`Failed to upload file: ${response.status}`);
          }
      
          const data = await response.json();
          alert("✅ File uploaded successfully!");
      
          // ✅ Update the data state with the correct file path          
            
          setCorrectionPanData((prevData) =>
            prevData.map((item) =>
                item.registrationNo === registrationNo
                    ? { ...item, PanReceiptPath: data.FilePath } // Use consistent casing
                    : item
            )
        );                
          // ✅ Force DataTable to redraw
          const table = $('#productsTable').DataTable();
          table.clear();
          table.rows.add(correctionPanData); // Update the table with the new data
          table.draw();
      
        } catch (error) {
          console.error("Upload error:", error);
          alert("❌ Failed to upload file.");
        }
      };

    return (

                  <table
                      ref={tableRef}
                      id="productsTable"
                      className="table table-bordered table-hover table-product"
                      style={{ width: '100%' }}
                  >
                      <thead>
                          <tr>
                              <th>Sr. No.</th>
                              <th>Date</th>
                              <th>Applicant Name</th>
                              <th>Registration No</th>
                              <th>Status</th>
                              <th>Comment</th>
                              <th>Submitted Form</th>
                              <th>PDFDocument</th>
                              <th>Photo</th>
                              <th>Signature</th>
                          </tr>
                      </thead>
                  </table>
            
  );
};
export default CorrectionPanApplicationAdminReport;